// useRouteのラッパー
// vitestでuseRouteのモックがうまくいかないことがあるのでラップする
import type { RouteLocationNormalized } from "vue-router";

export const useRouteWrapper = () => {
  return useRoute();
};

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    useRouteWrapper: () => RouteLocationNormalized;
  }
}
